export const navigation = [
    {
        name: 'Dashboard',
        url: '/dashboard',
        icon: 'fas fa-tachometer'
    },
    {
        name: 'Orders',
        url: '/orders',
        icon: 'fas fa-inbox'
    },
    {
        name: 'Drafts',
        url: '/drafts',
        icon: 'fas fa-paper-plane',
        roles: ['ADMIN']
    },
    {
        name: 'Projects',
        url: '/projects',
        icon: 'fas fa-box'
    },
    {
        name: 'Users',
        url: '/users',
        icon: 'fas fa-user'
    },

    // {
    //     name: 'Groups',
    //     url: '/groups',
    //     icon: 'fas fa-users'
    // },

/*
    {
        name: 'Quotes',
        url: '/quotes',
        icon: 'fas fa-file-invoice-dollar'
    },
*/
    {
        name: 'Builder',
        url: '/builder',
        icon: 'fas fa-pencil-ruler',
        children: [
/*
            {
                name: 'Quick Start',
                url: '/builder/draftdesigns',
                icon: 'fas fa-box-check'
            },
*/
            {
                name: 'Patterns',
                url: '/builder/patterns',
                icon: ['fas fa-ellipsis-v', 'fas fa-ellipsis-v', 'fas fa-ellipsis-v']
            },
            {
                name: 'Shapes',
                url: '/builder/shapes',
                icon: 'fas fa-shapes'
            },

        ]
    },

    // {
    //     name: 'Templates',
    //     url: '/templates',
    //     icon: 'fas fa-paint-roller',
    //     children: [
    //         {
    //             name: 'Add Template',
    //             url: '/templates/addtemp',
    //             icon: 'fas fa-box-check'
    //         },
    //         {
    //             name: 'List Templates',
    //             url: '/templates/listtemp',
    //             icon: 'fas fa-templates'
    //         },
    //         {
    //             name: 'Template Requests',
    //             url: '/templates/tempreq',
    //             icon: 'fas fa-templates'
    //         },

    //     ]
    // },

    {
        name: 'Tools',
        url: '/tools',
        icon: 'fas fa-toolbox',
        children: [
            {
                name: 'Pricing',
                url: '/tools/pricing',
                icon: 'fas fa-dollar-sign'
            },
            {
                name: 'Packaging',
                url: '/tools/packaging',
                icon: 'fas fa-box'
            }
        ]
    },
    // {
    //     name: 'Settings',
    //     url: '/settings',
    //     icon: 'fas fa-cogs',
    //     children: [
    //         {
    //             name: 'Categories',
    //             roles: ['CSR', 'ADMIN'],
    //             url: '/settings/categories',
    //             icon: 'fas fa-sitemap'
    //         },
    //         {
    //             name: 'Subcategories',
    //             roles: ['CSR', 'ADMIN'],
    //             url: '/settings/subcategories',
    //             icon: 'fas fa-sitemap'
    //         }
    //     ]
    // },

    //   {
    //     name: 'Dashboard',
    //     url: '/dashboard',
    //     icon: 'far fa-tachometer',
    //     badge: {
    //       variant: 'info',
    //       text: 'NEW'
    //     }
    //   }

];
